import { Component, OnInit } from '@angular/core';
import { BasePagedPage } from '../base-paged-page';
import { ApiService } from 'src/app/services/api.service';
import { PagedResponseModel } from 'src/app/models/common/paged-response.model';
import { PagedSearchModel } from 'src/app/models/common/paged-search.model';
import { ProductListItemModel } from 'src/app/models/catalog/product-list-item.model';
import { ProductLinksModel } from 'src/app/models/catalog/product-links.model';
import { MessageService } from 'src/app/services/message.service';

declare var bootstrap: any;

@Component({
    selector: 'app-product-links',
    templateUrl: './product-links.component.html',
    styleUrl: './product-links.component.scss',
    standalone: false
})
export class ProductLinksComponent extends BasePagedPage<string, ProductLinksModel> implements OnInit {

  public selected?: ProductLinksModel;

  public newLink?: ProductListItemModel;

  public searchLink = '';

  public searchedLinks: ProductListItemModel[] = [];

  public isSave = false;

  public constructor(private mApiService: ApiService, private mMessageService: MessageService) {
    super();
  }

  ngOnInit(): void {
    this.getData(1);
  }

  public getData(page?: number) {
    if (!page) { return; }

    this.isBusy = true;

    this.mApiService.getWithParams<PagedSearchModel<string>, PagedResponseModel<ProductLinksModel>>('/api/admin/catalog/product/links', {
      page: page,
      pageSize: 20,
      search: this.search
    }).subscribe({
      next: r => {
        this.items = r.items;

        this.page = page;
        this.pages = r.pages;

        this.isBusy = false;
      },
      error: () => this.isBusy = false
    });
  }

  public onSearch() {
    this.mApiService.getWithParams<PagedSearchModel<string>, PagedResponseModel<ProductListItemModel>>('/api/admin/catalog/product/list', {
      page: 1,
      pageSize: 10,
      search: this.searchLink
    }).subscribe({
      next: r => {
        this.searchedLinks = r.items;
      },
    });
  }

  public setLinks(item: ProductLinksModel) {
    this.searchedLinks = [];
    this.selected = JSON.parse(JSON.stringify(item));
    this.newLink = undefined;
  }

  public onSelect(item: ProductListItemModel) {
    if (!this.selected!.links.find(x => item.id == x.id)) {

      this.searchLink = item.name;
      this.newLink = item;

    } else {
      this.newLink = undefined;
    }
  }

  public onAdd() {
    this.selected!.links.push({
      id: this.newLink!.id,
      name: this.newLink!.name,
      image: this.newLink!.image,
      links: []
    });
    this.newLink = undefined;
    this.searchLink = '';
  }

  public deleteLink(item: ProductLinksModel) {
    if (confirm('Удалить запись?')) {
      this.selected?.links.splice(this.selected?.links.indexOf(item), 1);
    }
  }

  public saveLinks() {
    this.isSave = true;

    this.mApiService.post<{}, ProductLinksModel>('/api/admin/catalog/product/links/save', {
      id: this.selected!.id,
      links: this.selected!.links.map(x => x.id)
    }).subscribe({
      next: r => {
        this.isSave = false;
        this.items[this.items.indexOf(this.items.find(x => x.id == r.id)!)] = r;
        this.mMessageService.addMessage({ text: 'Связи сохранены', type: this.mMessageService.types.success });
        bootstrap.Modal.getInstance(document.getElementById('list-of-links-modal')).hide();
      },
      error: () => this.isSave = false
    })
  }
}

